
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[language]/events/[timespan]/[program]/[programInner]/[programInnerCat]",
      function () {
        return require("private-next-pages/[region]/[language]/events/[timespan]/[program]/[programInner]/[programInnerCat]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[language]/events/[timespan]/[program]/[programInner]/[programInnerCat]"])
      });
    }
  